import * as THREE from "three";

// V3 Toon material with 3-step ramp
export function createToonMaterial(
  color: THREE.ColorRepresentation,
): THREE.MeshToonMaterial {
  // Create 4-step gradient map (4x1 RGBA = 16 bytes)
  const colors = new Uint8Array(16);
  for (let i = 0; i < 16; i += 4) {
    // Lighter steps: 0.7, 0.85, 1.0 for better shading
    const brightness = i < 8 ? 0.7 : i < 12 ? 0.85 : 1.0;
    colors[i] = colors[i + 1] = colors[i + 2] = brightness * 255;
    colors[i + 3] = 255; // Alpha
  }
  const gradientMap = new THREE.DataTexture(
    colors,
    4,
    1,
    THREE.RGBAFormat,
    THREE.UnsignedByteType,
  );
  gradientMap.needsUpdate = true;
  gradientMap.magFilter = THREE.NearestFilter;
  gradientMap.minFilter = THREE.NearestFilter;
  gradientMap.generateMipmaps = false;

  return new THREE.MeshToonMaterial({
    color,
    gradientMap,
  });
}

// Add fresnel rim light via onBeforeCompile
export function addRimLight(material: THREE.Material): void {
  if (!("onBeforeCompile" in material)) return;

  (material as THREE.ShaderMaterial).onBeforeCompile = (shader) => {
    shader.fragmentShader = shader.fragmentShader.replace(
      "#include <dithering_fragment>",
      `
      #include <dithering_fragment>
      vec3 viewDir = normalize(vViewPosition);
      float rim = pow(1.0 - max(dot(vNormal, viewDir), 0.0), 2.0) * 0.55;
      gl_FragColor.rgb += vec3(1.0,0.86,0.70) * rim;
      `,
    );
  };
  material.needsUpdate = true;
}
